var React = require('react');

function WishlistedInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.9469 2.06301C3.24371 0.701163 4.98766 0 6.70801 0C8.45463 0 10.1993 0.69985 11.4974 2.06316L11.5016 2.06755L11.9811 2.58776L12.4668 2.08829C15.0961 -0.668381 19.4122 -0.667938 22.041 2.08962C24.6551 4.80359 24.6504 9.17419 22.0425 11.9115L22.0399 11.9142C20.0704 13.9609 18.1145 16.0184 16.1528 18.082C15.147 19.1401 14.1396 20.1999 13.128 21.2606L13.122 21.2668L13.0763 21.3127L13.0643 21.3237C12.4516 21.886 11.4431 21.9208 10.8279 21.2549L1.94553 11.8819L1.94378 11.88C-0.630127 9.14545 -0.666713 4.80649 1.9469 2.06301Z","fill":"currentColor"}));
}

WishlistedInline.defaultProps = {"width":"24","height":"22","viewBox":"0 0 24 22","fill":"none"};

module.exports = WishlistedInline;

WishlistedInline.default = WishlistedInline;
